import { Pipe, PipeTransform } from '@angular/core';
import { MediaResponseTime } from '../models/renault-lead-dto';


@Pipe({
    name: 'hoursLeads'
})
export class HoursLeadsPipe implements PipeTransform {

    transform(value: MediaResponseTime, args?: any): any {
        var returnString = "";


        if (value.Hours > 0 && value.Minutes > 0)
            returnString = value.Hours.toString() + " Horas " + value.Minutes.toString() + " Minutos ";

        else if (value.Hours > 0 && value.Minutes == 0)
            returnString = value.Hours.toString() + " Horas ";

        else if (value.Hours == 0 && value.Minutes > 0)
            returnString = value.Minutes.toString() + " Minutos ";


        return returnString;
    }

}
